<template lang="pug">
.full-auto.full-topbar
  topBar
  router-view
</template>

<script>
import topBar from "@/views/highlight/topBar";

export default {
  components: {
    topBar
  },
  destroyed() {
    $("html").removeClass("minimal hl");
    $("body").removeClass("minimal hl");
  },
  mounted() {
    $("html").addClass("minimal hl");
    $("body").addClass("minimal hl");
  }
};
</script>
